export default {
  setSelections(state, val) {
    state.selections = val.selection
  },
  setNotificationCategory(state, val){
  	state.notificationList.category = val.category;
  },
  setNotificationOnChangeState(state, val){
  	state.notificationList.onChangeState = val.state;
  }
}



// WEBPACK FOOTER //
// ./src/Crm/store/mutations.js